/* Wiley Records — tiny, dependency-free JS: menu drawer, filter drawer,
   sort auto-submit, predictive search. */
(function () {
  'use strict';

  /* ----- newsletter: loading feedback + focus the result message ----- */
  var newsletterForm = document.querySelector('[data-newsletter-form]');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function () {
      var btn = newsletterForm.querySelector('[data-newsletter-submit]');
      var label = newsletterForm.querySelector('[data-newsletter-submit-label]');
      if (!btn || !label || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      label.textContent = strings.subscribing || label.textContent;
      /* full page reload follows Shopify's response, so no need to revert state */
    });
  }
  var newsletterMessage = document.querySelector('[data-newsletter-message]');
  if (newsletterMessage) newsletterMessage.focus();

  /* Placeholder hides on a genuine click/tap, not on :focus (which some
     browsers restore across a plain page refresh with nothing typed). */
  var newsletterInput = document.querySelector('.newsletter-form__input');
  if (newsletterInput) {
    newsletterInput.addEventListener('pointerdown', function () {
      newsletterInput.classList.add('was-clicked');
    });
  }

  /* ----- mobile menu drawer ----- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  var menuClose = document.querySelector('[data-menu-close]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');

  function setMenu(open) {
    if (!menuDrawer) return;
    menuDrawer.classList.toggle('is-open', open);
    if (menuOverlay) menuOverlay.hidden = !open;
    if (menuToggle) menuToggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (menuToggle) menuToggle.addEventListener('click', function () { setMenu(true); });
  if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
  if (menuOverlay) menuOverlay.addEventListener('click', function () { setMenu(false); });

  /* ----- collection filter drawer (mobile) -----
     Event-delegated on document rather than bound to the specific toggle/
     close/overlay elements: facets.js replaces the whole collection root's
     innerHTML on every AJAX filter update, which would otherwise silently
     detach direct listeners after the very first filter change (the toggle
     button would stop reopening the drawer at all without a page reload). */
  function setFilters(open) {
    var filterDrawer = document.querySelector('[data-filter-drawer]');
    var filterOverlay = document.querySelector('[data-filter-overlay]');
    if (!filterDrawer) return;
    filterDrawer.classList.toggle('is-open', open);
    if (filterOverlay) filterOverlay.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]')) setFilters(true);
    else if (e.target.closest('[data-filter-close]')) setFilters(false);
    else if (e.target.matches('[data-filter-overlay]')) setFilters(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setMenu(false); setFilters(false); hideResults(); }
  });

  /* ----- filter group search: instant client-side narrowing, no network ----- */
  function bindFilterSearch() {
    document.querySelectorAll('[data-filter-search]').forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      var body = input.closest('.filter-group__body');
      var list = body.querySelector('[data-filter-values]');
      var noMatch = body.querySelector('[data-filter-no-match]');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var visible = 0;
        list.querySelectorAll('li').forEach(function (li) {
          var match = !q || li.getAttribute('data-filter-value-label').indexOf(q) > -1;
          li.hidden = !match;
          if (match) visible++;
        });
        if (noMatch) noMatch.hidden = visible !== 0;
      });
    });
  }
  bindFilterSearch();
  document.addEventListener('shopify:section:load', bindFilterSearch);
  document.addEventListener('wiley:collection-rendered', bindFilterSearch);

  /* ----- filter form: keep current sort when applying (no-JS-adjacent
     fallback path — facets.js's own AJAX submit handler already preserves
     sort_by, this only matters if that handler somehow didn't run).
     Delegated for the same reason as the filter drawer above. ----- */
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-filter-form]')) return;
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort_by');
    if (sort && !e.target.querySelector('input[name="sort_by"]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'sort_by';
      hidden.value = sort;
      e.target.appendChild(hidden);
    }
  });

  /* ----- sort select: reload with sort_by, keep filters -----
     Delegated: this select is inside the collection root facets.js
     replaces on every AJAX filter update, so a directly-bound listener
     would stop working after the first filter change. */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort-select]')) return;
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', e.target.value);
    params.delete('page');
    window.location.search = params.toString();
  });

  /* ----- predictive search ----- */
  var wrap = document.querySelector('[data-predictive-search]');
  var input = wrap && wrap.querySelector('[data-search-input]');
  var results = wrap && wrap.querySelector('[data-search-results]');
  var debounceTimer = null;
  var lastQuery = '';

  function hideResults() {
    if (results) { results.hidden = true; results.innerHTML = ''; }
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  var strings = window.wileyStrings || {};

  function render(products, query) {
    if (!products.length) {
      results.innerHTML = '<a class="pr__all" href="' + window.routes.search_url +
        '?q=' + encodeURIComponent(query) + '&type=product">' +
        esc(strings.noQuickMatches || 'No quick matches — search everything') + ' &rarr;</a>';
      results.hidden = false;
      return;
    }
    var html = products.map(function (p) {
      var img = '';
      if (p.featured_image && p.featured_image.url) {
        var sep = p.featured_image.url.indexOf('?') > -1 ? '&' : '?';
        img = '<img src="' + esc(p.featured_image.url + sep + 'width=84') + '" alt="" width="42" height="42" loading="lazy">';
      }
      var price = p.price ? '<span class="pr__meta mono">' + esc(p.price) + '</span>' : '';
      return '<a href="' + esc(p.url) + '">' + img +
        '<span><span class="pr__title">' + esc(p.title) + '</span><br>' +
        '<span class="pr__meta">' + esc(p.vendor || '') + '</span></span>' + price + '</a>';
    }).join('');
    html += '<a class="pr__all" href="' + window.routes.search_url +
      '?q=' + encodeURIComponent(query) + '&type=product">' +
      esc(strings.seeAll || 'See all results') + ' &rarr;</a>';
    results.innerHTML = html;
    results.hidden = false;
  }

  if (input && results && window.routes) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { hideResults(); return; }
      debounceTimer = setTimeout(function () {
        if (q === lastQuery) return;
        lastQuery = q;
        fetch(window.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products.map(function (p) {
              return {
                title: p.title,
                url: p.url,
                vendor: p.vendor,
                price: p.price ? p.price : null,
                featured_image: p.featured_image ? { url: p.featured_image.url } : (p.image ? { url: p.image } : null)
              };
            }), q);
          })
          .catch(hideResults);
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) hideResults();
    });

    /* arrow-key navigation through results */
    input.addEventListener('keydown', function (e) {
      if (results.hidden) return;
      var links = results.querySelectorAll('a');
      if (!links.length) return;
      var current = results.querySelector('a.is-active');
      var idx = current ? Array.prototype.indexOf.call(links, current) : -1;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = e.key === 'ArrowDown' ? (idx + 1) % links.length : (idx - 1 + links.length) % links.length;
        if (current) current.classList.remove('is-active');
        links[idx].classList.add('is-active');
        links[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && current) {
        e.preventDefault();
        window.location.href = current.href;
      }
    });
  }

  /* ----- "/" focuses search from anywhere ----- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
    if (input) { e.preventDefault(); input.focus(); input.select(); }
  });

  /* ----- sticky buy bar: appears once the main button scrolls away ----- */
  var buyBar = document.querySelector('[data-buy-bar]');
  var mainForm = document.getElementById('main-buy-form');
  if (buyBar && mainForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      buyBar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '-60px 0px 0px 0px' }).observe(mainForm);
  }

  /* ----- recently viewed (localStorage, product pages only) ----- */
  var recent = document.querySelector('[data-recent]');
  if (recent) {
    var KEY = 'wiley:recent';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }

    var current = {
      handle: recent.getAttribute('data-recent-handle'),
      title: recent.getAttribute('data-recent-title'),
      url: recent.getAttribute('data-recent-url'),
      image: recent.getAttribute('data-recent-image'),
      price: recent.getAttribute('data-recent-price')
    };

    var others = list.filter(function (p) { return p && p.handle && p.handle !== current.handle; });

    if (others.length) {
      var row = recent.querySelector('[data-recent-row]');
      row.innerHTML = others.slice(0, 6).map(function (p) {
        var img = p.image
          ? '<img src="' + esc(p.image) + '" alt="" width="120" height="120" loading="lazy">'
          : '<span class="recent-strip__blank"></span>';
        return '<a class="recent-strip__item" href="' + esc(p.url) + '">' + img +
          '<span class="recent-strip__name">' + esc(p.title) + '</span>' +
          '<span class="recent-strip__price mono">' + esc(p.price) + '</span></a>';
      }).join('');
      recent.hidden = false;
    }

    others.unshift(current);
    try { localStorage.setItem(KEY, JSON.stringify(others.slice(0, 8))); } catch (e) { /* storage full or blocked */ }
  }
})();
